<div class="container">
    <app-custcardview1
        [ngClass]="{ isScrolled: isScrolled, isNotification: isNotificationTabChosen, isHeaaderHidden: isHeaaderHidden }"
        [customerId]="customerId"
        [custcard_3]="custcard_3"
        (openSmsDialog)="openSmsDialog()"
    ></app-custcardview1>
    <app-custcardview2 [customerId]="customerId" [custcard_3]="custcard_3" (openSmsDialog)="openSmsDialog()"></app-custcardview2>
    <app-custcardview4 [customerId]="customerId"></app-custcardview4>
</div>

<p-dialog
    class="dialog__panel"
    [(visible)]="isDialogVisible"
    [resizable]="false"
    [draggable]="false"
    [modal]="true"
    [responsive]="false"
    [dismissableMask]="true"
>
    <h3 class="dialog__title">שליחת סמס ללקוח</h3>

    <div class="input-wrapper" [ngClass]="{ 'input-wrapper_with-details': isDialogErrorVisible, 'input-wrapper_error': isDialogErrorVisible }">
        <input class="input" #smsInput [(ngModel)]="smsMessage" type="text" autocomplete="off" />
        <span class="input-details">השדה הזה לא יכול להיות ריק</span>
    </div>

    <div class="dialog__buttons">
        <button class="button button_size_small button_theme_main" (click)="hideSmsDialog(true)">לשלוח</button>
        <button class="button button_size_small button_theme_gray-line" (click)="hideSmsDialog(false)">ביטול</button>
    </div>
</p-dialog>

<p-messages class="messages"></p-messages>
